<div class="container" *ngIf="!loadIndicator; else loading">
  <ng-container *ngIf="participants != 0; else nodata">

    <div class="tab-content team">
      <div class="team-container"
           *ngFor="let participant of participants;index as index"
           id="{{participant?.participant_id}}"
           [ngClass]="{'incomplete': participant?.incomplete}">
        <div class="flex_block align-items-center txt-right">
          <img [src]="participant?.original.avatar" alt="team_image"/>
          <div class="info">
            <h1>{{participant?.original.participant_name|truncate :participant.truncate}}</h1>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #nodata>
    <div class="no-data " *ngIf="participants?.length==0">
      <h2>{{globalService.customLang.no_winners}}</h2>
    </div>
  </ng-template>

</div>
<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
